import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { B2BLanding } from '../components/B2BLanding';
import { trindContent, TRIND_HERO } from '../content/trindContent';

export default function TrindPage() {
  const { language } = useLanguage();
  return <B2BLanding content={trindContent[language]} seoKey="trind" path="/rinforzante-unghie-trind" heroImage={TRIND_HERO} testId="trind-page" />;
}
